import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import EndOfServiceTable from "./components/table";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import PaginationComponent from "../../../../components/table/tablePagination";
import {
  getStaffPayrollList,
  terminateUser,
} from "../../../../../services/workspace/payroll.service";

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "/payroll" },
  { label: "End Of Service", path: "" },
];

function EndOfService() {
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [isTerminate, setIsTerminate] = useState(false);

  const fetchData = useCallback(() => {
    setLoading(true);
    getStaffPayrollList({ search, page: currentPage, limit })
      .then((response) => {
        setLoading(false);
        setTableData(response.data);
        setTotalData(response.total);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch Staff data!");
        console.error("Error fetching data: ", error);
      });
  }, [search, currentPage, limit, reload]);

  const handleTerminate = (e) => {
    setIsTerminate(true);
    terminateUser({ user_id: e.user_id })
      .then((response) => {
        // setTableData((prev) => ({
        //   ...prev,
        //   data: prev.data.filter((item) => item.id != selectedId),
        // }));
        setIsOpenSheet(false);
        setIsTerminate(false);
        setReload(!reload);
        toast.success("User Terminate successfully!");
      })
      .catch((error) => {
        toast.error("Failed to delete role.");
        setIsTerminate(false);
      });
  };
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const timer = setTimeout(fetchData, search ? 500 : 0); // Debounce search input
    return () => clearTimeout(timer);
  }, [fetchData]);
  return (
    <div className="flex flex-col ">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={handleSearchChange}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-2">
        <EndOfServiceTable
          fetchData={fetchData}
          search={search}
          tableData={tableData}
          loading={loading}
          handleTerminate={handleTerminate}
          setIsOpenSheet={setIsOpenSheet}
          isOpenSheet={isOpenSheet}
          isTerminate={isTerminate}
        />
      </div>
      <PaginationComponent
        itemPerPage={limit}
        currentPage={currentPage}
        totalItems={totalData}
        paginate={setCurrentPage}
      />
    </div>
  );
}

export default EndOfService;
